import React from 'react';
import { User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const ProfileTab = ({ profileData, userEmail, saving, onChange, onSubmit }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <User className="w-5 h-5 text-yellow-400" />
        Profile Information
      </CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-purple-100">Full Name</Label>
            <Input
              id="name"
              name="name"
              value={profileData.name}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              data-testid="profile-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-purple-100">Email</Label>
            <Input
              id="email"
              value={userEmail || ''}
              disabled
              className="bg-purple-900/30 border-purple-700 text-purple-300"
            />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label htmlFor="phone" className="text-purple-100">Phone Number</Label>
            <Input
              id="phone"
              name="phone"
              value={profileData.phone}
              onChange={onChange}
              placeholder="(555) 123-4567"
              className="bg-purple-900/50 border-purple-600 text-white placeholder:text-purple-400"
              data-testid="profile-phone-input"
            />
          </div>
        </div>
        <Button
          type="submit"
          disabled={saving}
          className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
          data-testid="save-profile-btn"
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </form>
    </CardContent>
  </Card>
);
